import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ArrayMapperService {
    constructor() { }

    /**
     * Maps an array of objects to an object using each item's id as the key.
     * If the input is already an object, it returns the object as is.
     *
     * @param input - The array of objects or an object.
     * @returns An object with keys as item ids and values as the corresponding objects, or the input object.
     */
    public mapArrayToObject<T extends { id: string | number }>(input: T[] | Record<string | number, T>): Record<string | number, T> {
        if (Array.isArray(input)) {
            return input.reduce((acc, item) => {
                acc[item.id] = item;

                return acc;
            }, {} as Record<string | number, T>);
        } else {
            return input;
        }
    }
}
